import React, { Component } from 'react';

export default class DocumentDownloadLink extends Component {

    constructor(props) {
        super(props);
    }

    renderDownloadIcon() {
		return <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
		            xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_2027_3559)">
				<path
					d="M8.23169 15.6017C8.46386 15.834 8.73953 16.0183 9.04295 16.144C9.34637 16.2697 9.67159 16.3345 10 16.3345C10.3285 16.3345 10.6537 16.2697 10.9571 16.144C11.2605 16.0183 11.5362 15.834 11.7684 15.6017L14.4442 12.9258C14.5877 12.7672 14.6646 12.5594 14.6591 12.3455C14.6536 12.1317 14.5661 11.9282 14.4147 11.7771C14.2633 11.626 14.0595 11.5389 13.8457 11.5338C13.6318 11.5288 13.4242 11.6062 13.2659 11.75L10.8275 14.1892L10.8334 1.33333C10.8334 1.11232 10.7456 0.900358 10.5893 0.744078C10.433 0.587797 10.221 0.5 10 0.5C9.77901 0.5 9.56705 0.587797 9.41077 0.744078C9.25449 0.900358 9.16669 1.11232 9.16669 1.33333L9.15919 14.1733L6.73419 11.75C6.57783 11.5937 6.36579 11.506 6.14473 11.5061C5.92367 11.5062 5.7117 11.594 5.55544 11.7504C5.39919 11.9068 5.31145 12.1188 5.31152 12.3399C5.3116 12.5609 5.39949 12.7729 5.55586 12.9292L8.23169 15.6017Z"
					fill="#00549E"/>
				<path
					d="M19.1667 13.8333C18.9457 13.8333 18.7337 13.921 18.5774 14.0773C18.4211 14.2336 18.3333 14.4456 18.3333 14.6666V17.9999C18.3333 18.2209 18.2455 18.4329 18.0893 18.5892C17.933 18.7455 17.721 18.8333 17.5 18.8333H2.5C2.27899 18.8333 2.06702 18.7455 1.91074 18.5892C1.75446 18.4329 1.66667 18.2209 1.66667 17.9999V14.6666C1.66667 14.4456 1.57887 14.2336 1.42259 14.0773C1.26631 13.921 1.05435 13.8333 0.833333 13.8333C0.61232 13.8333 0.400358 13.921 0.244078 14.0773C0.0877974 14.2336 0 14.4456 0 14.6666L0 17.9999C0 18.663 0.263392 19.2988 0.732233 19.7677C1.20107 20.2365 1.83696 20.4999 2.5 20.4999H17.5C18.163 20.4999 18.7989 20.2365 19.2678 19.7677C19.7366 19.2988 20 18.663 20 17.9999V14.6666C20 14.4456 19.9122 14.2336 19.7559 14.0773C19.5996 13.921 19.3877 13.8333 19.1667 13.8333Z"
					fill="#00549E"/>
			</g>
			<defs>
				<clipPath id="clip0_2027_3559">
					<rect width="20" height="20" fill="white"
					      transform="translate(0 0.5)"/>
				</clipPath>
			</defs>
		</svg>;
	}

    render() {
        return (
            <a href={ this.props.link } target="_blank">
                <span className={ 'asset-title' }>
                    { this.props.title }
                </span>
                { this.renderDownloadIcon() }
                <span className="sr-only"> will open in a new tab or window</span>
        </a>
        );
    }
}